<script>
  export default {
    page: {
      title: '404',
      meta: [{ name: 'description', content: '404' }],
    },
    props: {
      resource: {
        type: String,
        default: '',
      },
    },
    computed: {
      message(){
        return `404 ${this.resource ? this.resource : '' }Not Found`
      },
    },
  }
</script>

<template>
  <section class="fl-al-center f-h-vh100">
    <h1>
      404 
      <template v-if="resource">
        {{ resource }}
      </template>
      Not Found
    </h1>
  </section>
</template>
